module.exports = __webpack_public_path__ + "img/insurance.7d4501c1.svg";